document.querySelectorAll("[data-fostr-open-contentdrawer-id]").forEach((opener) => {

  /* All filter accordions */
  const filters = document.querySelectorAll('#fostr-contentdrawer-filters #FacetsWrapperDesktop details');

  /* Return focus to the element that opened the drawer */
  const theopener = opener;
 
  /* target content drawer */
  const contentdrawer = document.getElementById(opener.getAttribute('data-fostr-open-contentdrawer-id'));

  /* Child elements */
  const closebuttons = contentdrawer.querySelectorAll('.fostr-contentdrawer__close, .fostr-contentdrawer__additional-close-button');
  const curtain = contentdrawer.querySelector('.fostr-contentdrawer__curtain');
  const spacer = contentdrawer.querySelector('.fostr-contentdrawer__spacer');

  /* First focusable element or the a button */
  const focusable = getFocusableElements(contentdrawer) || closebutton[0];
  const firstFocusable = focusable[0];

  function open() {
    checkSelectedOnOpen();
    contentdrawer.setAttribute('aria-expanded', 'true');
    contentdrawer.classList.add('active');
    disableBodyScroll();
    trapFocus(contentdrawer, firstFocusable);
  }

  function close() {
    closeFiltersAccordions();
    contentdrawer.setAttribute('aria-expanded', 'false');
    contentdrawer.classList.remove('active');
    enableBodyScroll();
    theopener.focus();
  }

  function disableBodyScroll() {
    document.body.classList.add('overflow-hidden');
  }

  function enableBodyScroll() {
    document.body.classList.remove('overflow-hidden');
  }

  /* checks if filters have any selected input within them, if true opens the accordion */
  function checkSelectedOnOpen() {
    filters.forEach(filter => {
      const checkboxes = filter.querySelectorAll('input')
      checkboxes.forEach(checkbox => {
        if(checkbox.checked) {
          filter.setAttribute('open', '')
          filter.querySelector('summary').setAttribute('aria-expanded', "true")
        }
      })
    })
  }

  /* Closing all accordions */
  function closeFiltersAccordions() {
    filters.forEach(filter => {
      filter.removeAttribute('open')
      filter.querySelector('summary').setAttribute('aria-expanded', "false")
    })
  }

  opener.addEventListener('click', (event) => {
    open();
  });

  closebuttons.forEach( (closebutton) => {
    closebutton.addEventListener('click', (event) => {
      close();
    });
  })

  spacer.addEventListener('click', (event) => {
    close();
  });

  curtain.addEventListener('click', (event) => {
    close();
  });

});


